import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import API_URL from '@/common/url'
import JwtService from '@/common/jwt.service'

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      'Authorization'
      ] = `Bearer ${JwtService.getToken()}`
  },

  post(resource, params, configs) {
    return Vue.axios.post(`${resource}`, params, configs)
  },

  get(resource, configs) {
    return Vue.axios.get(`${resource}`, configs)
  },

  put(resource, params, configs) {
    return Vue.axios.put(`${resource}`, params, configs)
  },

  delete(resource, params, configs) {
    return Vue.axios.delete(`${resource}`,  configs)
  },
}

export default ApiService



// WEBPACK FOOTER //
// ./src/common/api.service.js